module.exports = __webpack_public_path__ + "img/share-sample.b226dcbe.png";